import { jsx as n } from "react/jsx-runtime";
import { dividerVariants as t } from "./Divider.variants.js";
const f = ({
  className: i,
  isDecorative: o = !1,
  orientation: r = t.definition().defaultVariants.orientation,
  ...a
}) => {
  const { root: e } = t;
  return /* @__PURE__ */ n(
    "hr",
    {
      "aria-orientation": !o && typeof r == "string" ? r : void 0,
      className: e({ className: i, orientation: r }),
      role: o ? "none" : "separator",
      ...a
    }
  );
};
export {
  f as Divider
};
